import { Box, Card, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import CustomTable from "../common/CustomTable";

const LatestOrders = ({ activities, ...props }) => {
  const options = {
    filterType: "checkbox",
    selectableRows: false,
    filter: false,
    download: false,
    print: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true
      }
    }
  };
  const columns = [
    {
      name: "contractNumber",
      label: "#",
      options: {
        customBodyRender: (value, tableMeta) => {
          const { rowIndex } = tableMeta;
          return <Box>{rowIndex + 1}</Box>;
        }
      }
    },
    {
      name: "type",
      label: "Loại hình",
      options: {
        customBodyRender: value => <Box>{value}</Box>
      }
    },
    {
      name: "contractNumber",
      label: "Mã HĐ",
      options: {
        customBodyRender: value => <Box>{value}</Box>
      }
    },
    {
      name: "userName",
      label: "Người GD",
      options: {
        customBodyRender: value => value
      }
    },
    {
      name: "customerName",
      label: "Khách hàng",
      options: {
        customBodyRender: value => value
      }
    },
    {
      name: "createdAt",
      label: "Ngày GD",
      options: {
        customBodyRender: value => dayjs(value).format("DD/MM/YYYY")
      }
    },
    {
      name: "description",
      label: "Diễn giải",
      options: {
        customBodyRender: value => value
      }
    },
    {
      name: "income",
      label: "Đã thu",
      options: {
        customBodyRender: value => `${value?.toLocaleString("en-US") || 0} VNĐ`
      }
    },
    {
      name: "outcome",
      label: "Đã chi",
      options: {
        customBodyRender: value => `${value?.toLocaleString("en-US") || 0} VNĐ`
      }
    },
    {
      name: "notes",
      label: "Ghi chú",
      options: {
        customBodyRender: value => value
      }
    }
  ];
  return (
    <Card {...props}>
      <CustomTable
        title={<Typography variant="h2">Giao dịch trong ngày</Typography>}
        data={activities}
        options={options}
        columns={columns}
        id="giao-dich-trong-ngay"
      />
    </Card>
  );
};

LatestOrders.propTypes = {
  activities: PropTypes.array.isRequired
};

export default LatestOrders;
